<template>
  <div class="user-add-container">
    <div class="back">
      <span @click="$router.go(-1)"><i class="iconfont icon-back"></i>返回</span>
    </div>
    <div class="content">
      <div class="title">日志详细信息</div>
      <div class="detail">
        <div class="form"  >
          <el-form ref="form" :model="form" label-width="160px">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="操作模块："  >
                    <span class="value">{{form.modul}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="请求方法：">
                  <span class="value">{{form.method}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="操作类型："  >
                  <span class="value">{{form.type}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="操作描述：" >
                  <span class="value">{{form.description}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="请求用户名称：" >
                  <span class="value">{{form.userName}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="请求IP：" >
                  <span class="value">{{form.ip}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
               <el-col :span="12">
                <el-form-item label="请求URI：" >
                    <span class="value">{{form.uri}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="创建时间：" >
                    <span class="value">{{form.createTime}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="请求参数：">
                  <span class="value">{{form.requParam}}</span>
                </el-form-item>
              </el-col>
            </el-row>
             <el-row :gutter="20">
              <el-col :span="20">
                <el-form-item label="返回结果："  >
                  <span class="value">{{form.respParam}}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryOperationDetail } from '@/api/logger'
export default {
  data() {
    return {
      form:{},
      id: ''
    }
  },
  created() {
    this.id = this.$route.query.id
    this.initFormData()
  },
  methods: {
    initFormData() {
      const params = { id: this.id }
      console.log(this.id)
      queryOperationDetail(params)
        .then(res => {
          this.form = res.data
        })
    }
  }
}
</script>

<style lang="less" scoped>
.user-add-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  .back {
    color: #42a3df;
    font-size: 20px;
    font-weight: bold;
    padding-bottom: 10px;
    span {
      cursor: pointer;
    }
    .iconfont {
      margin-right: 10px;
    }
  }
  .content {
    flex: 1;
    min-height: 0;
    width: 100%;
    padding: 20px 20px;
    background: #fff;
    box-shadow: 0 0 6px 1px #acacac;
    overflow-y: auto;
    .title {
      font-size: 18px;
      line-height: 40px;
      font-weight: bold;
      color: #1f7eb8;
    }
    .detail {
      display: flex;
      padding-top: 30px;
      .btns {
        padding: 30px 160px 60px;
      }
      .avatar {
        .img {
          padding: 30px 10px;
          border: 1px solid #bbb;
        }
      }
      .form {
        flex: 1;
        min-width: 0;
        max-width: 1100px;
        .value {
          display: inline-block;
          width: 100%;
          padding: 0 16px;
          line-height: 41px;
        }
      }
    }
  }
  #map-container {
    width: 100%;
    height: 400px;
    box-shadow: 0 0 10px 1px #acacac;
  }
}
</style>
<style lang="less">
.equipment-add-container {
  .el-form-item__label {
    color: #1a2550;
    padding: 0 30px 0 0;
  }
  .el-select,
  .el-input {
    width: 100%;
  }
}
.formedit{
  input::-webkit-input-placeholder { /* WebKit, Blink, Edge */
      color: #fff !important;
  }
  i{
    display: none;
  }
  .el-input.is-disabled .el-input__inner{
          cursor: auto;
        background-color: #fff;
        border:0;
  }
}

</style>